import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import "./main.scss";
// import PLS369FrontImage from "./pls369front.png";
// import PLS369EyeImage from "./pls369eye.png";
import BackgroundText from "./Background/Background";
import VideoPlayer from "./VideoPlayer";
import BackgroundCarousel from "./Background/BackgroundCarousel";
//import RaveBackground from "./RaveBackground";
//import Background3 from "./Background3.mp4";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#ff00ff",
    },
    background: {
      default: "#0a0a0a",
      paper: "#141414",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

interface TokenData {
  price: string;
  priceChange24h: string;
  marketCap: string;
  volume24h: string;
  liquidity: string;
  pairAddress: string;
  trades24h: {
    buys: number;
    sells: number;
  } | null;
  volume24hChange: string;
}

const TOKEN_CONTRACT = "0xF46DbFdB381e90B97586eD792b5201FCeCc93Ef0";
const PAIR_ADDRESS = "0xb5202a6760823131793C64C8da8aC8Bf0d6a3669";

const App: React.FC = () => {
  const backgroundVideos = [
    { id: 1, src: "/Videos/Background2.mp4" },
    { id: 2, src: "/Videos/smokingbabe.mp4" },
    { id: 3, src: "/Videos/smokingcigarette.mp4"},
  ];

  const [tokenData, setTokenData] = useState<TokenData>({
    price: "0",
    priceChange24h: "0",
    marketCap: "0",
    volume24h: "0",
    liquidity: "0",
    pairAddress: PAIR_ADDRESS,
    trades24h: null,
    volume24hChange: "0",
  });

  const [showCopyNotification, setShowCopyNotification] = useState(false);
  const [copyButtonAnimating, setCopyButtonAnimating] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(TOKEN_CONTRACT);
      setCopyButtonAnimating(true);
      setShowCopyNotification(true);

      // Remove notification after 2 seconds
      setTimeout(() => {
        setShowCopyNotification(false);
      }, 2000);

      // Remove button animation class after animation completes
      setTimeout(() => {
        setCopyButtonAnimating(false);
      }, 500);
    } catch (err) {
      // console.error("Failed to copy:", err);
    }
  };

  const fetchTokenData = async (): Promise<void> => {
    const maxRetries = 3;
    let retryCount = 0;

    const tryFetch = async (): Promise<void> => {
      try {
        const response = await fetch(
          `https://api.dexscreener.com/latest/dex/pairs/pulsechain/${PAIR_ADDRESS}`,
          {
            headers: {
              Accept: "application/json",
              "Cache-Control": "no-cache",
            },
            cache: "no-store",
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const pair = data.pair;

        if (pair) {
          // console.log("Full pair data:", pair); // Add this line to inspect the data structure

          // Looking at their API, ATH might be in priceUsd object
          // console.log("Price data:", {
          //   price: pair.priceUsd,
          //   priceObj: pair.price,
          //   allTimeHigh: pair.athPrice, // It might be here
          //   priceHistory: pair.priceHistory, // Or might be calculable from here
          // });

          // console.log("Volume Change Data:", {
          //   rawVolumeChange: pair.volume?.h24ChangePercent,
          //   volumeH24: pair.volume?.h24,
          //   volumeChangePath1: pair.volume?.change24h,
          //   volumeChangePath2: pair.volumeChange?.h24,
          //   fullVolume: pair.volume,
          // });

          const volumeChange =
            pair.volume?.h24ChangePercent !== undefined
              ? pair.volume.h24ChangePercent
              : (((pair.volume?.h24 || 0) - (pair.volume?.h24_previous || 0)) /
                  (pair.volume?.h24_previous || 1)) *
                100;
          setTokenData({
            price: pair.priceUsd || pair.price || "0",
            priceChange24h: pair.priceChange?.h24 || "0",
            marketCap: pair.fdv || "0",
            volume24h: pair.volume?.h24 || "0",
            volume24hChange: volumeChange.toString(),
            liquidity: pair.liquidity?.usd || "0",
            pairAddress: PAIR_ADDRESS,
            trades24h: {
              buys: pair.txns?.h24?.buys || 0,
              sells: pair.txns?.h24?.sells || 0,
            },
          });
        }
      } catch (error) {
        //console.error(`Attempt ${retryCount + 1} failed:`, error);
        if (retryCount < maxRetries) {
          retryCount++;
          //console.log(`Retrying... Attempt ${retryCount + 1} of ${maxRetries}`);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          return tryFetch();
        }
        //console.error("Max retries reached. Failed to fetch data.");
      }
    };

    await tryFetch();
  };

  useEffect(() => {
    fetchTokenData();
    const interval = setInterval(fetchTokenData, 60000);
    return () => clearInterval(interval);
  }, []);

  const formatNumber = (num: string) => {
    const n = parseFloat(num);
    if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
    if (n >= 1e3) return `${(n / 1e3).toFixed(2)}K`;
    return `${n.toFixed(2)}`;
  };

  const [showParticles, setShowParticles] = useState(true);
  // ... existing state declarations ...

  const toggleParticles = () => {
    setShowParticles((prev) => !prev);
    // Save preference to localStorage
    localStorage.setItem("showParticles", (!showParticles).toString());
  };

  // Load preference on mount
  useEffect(() => {
    const savedPreference = localStorage.getItem("showParticles");
    if (savedPreference !== null) {
      setShowParticles(savedPreference === "true");
    }
  }, []);

  //const isNavVisible = useNavScroll();

  return (
    
    <ThemeProvider theme={theme}>
      
      <Box className="app-container">
        <div className="background-gradient" />
        <BackgroundText />

        {/* {showParticles && (
          <RaveBackground
            tradingData={tokenData}
            showParticles={showParticles}
          />
        )} */}
        <BackgroundCarousel
          videos={backgroundVideos.map((video, index) => ({
            ...video,
            uniqueKey: `${video.id}-${index}`, // Add a unique key for each video
          }))}
          showParticles={showParticles}
        />

        <Box className="header">
          <Container maxWidth="xl">
            <Box className="nav-content">
              <Box className="logo-section">
                <Typography className="label">COMMUNITY TAKEOVER</Typography>
              </Box>

              <Box className="trading-stats">
                <Box className="stat-item">
                  <Typography className="label">Price</Typography>
                  <Typography className="value">
                    ${parseFloat(tokenData.price).toFixed(8)}
                  </Typography>
                </Box>
                <Box className="stat-item">
                  <Typography className="label">24h Change</Typography>
                  <Typography
                    className={`value ${
                      parseFloat(tokenData.priceChange24h) >= 0
                        ? "positive"
                        : "negative"
                    }`}
                  >
                    {parseFloat(tokenData.priceChange24h).toFixed(2)}%
                  </Typography>
                </Box>
                <Box className="stat-item">
                  <Typography className="label">24h Volume</Typography>
                  <Typography className="value">
                    ${formatNumber(tokenData.volume24h)}
                  </Typography>
                </Box>
                <Box className="stat-item">
                  <Typography className="label">24h Trades</Typography>
                  <Typography className="value">
                    {tokenData.trades24h
                      ? `${
                          tokenData.trades24h.buys + tokenData.trades24h.sells
                        }`
                      : "0"}
                  </Typography>
                </Box>
              </Box>
              <Box className="contract-display">
                <Typography className="contract-text" variant="body2">
                  {TOKEN_CONTRACT.slice(0, 6)}...{TOKEN_CONTRACT.slice(-4)}
                </Typography>
                <IconButton
                  onClick={handleCopy}
                  className={`copy-button ${
                    copyButtonAnimating ? "copied" : ""
                  }`}
                  aria-label="Copy contract address"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                      fill="currentColor"
                    />
                  </svg>
                </IconButton>
                <div
                  className={`copy-notification ${
                    showCopyNotification ? "show" : ""
                  }`}
                >
                  Contract copied!
                </div>
              </Box>

              <Box className="social-links">
                <IconButton
                  onClick={toggleParticles}
                  className={`social-button ${
                    !showParticles ? "disabled" : ""
                  }`}
                  aria-label="Toggle particles"
                  title="Toggle Background Video"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill={showParticles ? "currentColor" : "none"}
                    />
                    <path
                      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
                <IconButton
                  href="https://x.com/369PLS"
                  target="_blank"
                  className="social-button"
                  aria-label="X (Twitter)"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.99 3H20.25L13.88 10.37L21.5 21H15.37L10.61 14.52L5.14 21H1.88L8.65 13.16L1.38 3H7.66L11.98 8.92L16.99 3ZM16.17 19.19H17.98L6.82 4.71H4.87L16.17 19.19Z"
                      fill="currentColor"
                    />
                  </svg>
                </IconButton>
                <IconButton
                  href="https://t.me/PLS_369"
                  target="_blank"
                  className="social-button"
                  aria-label="Telegram"
                >
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path
                      fill="currentColor"
                      d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
                    />
                  </svg>
                </IconButton>
                <IconButton
                  href={`https://dexscreener.com/pulsechain/${PAIR_ADDRESS}`}
                  target="_blank"
                  className="social-button"
                  aria-label="DexScreener"
                >
                  <img
                    src={"/Images/DexScreener.png"}
                    alt="DexScreener"
                    width="24"
                    height="24"
                  />
                </IconButton>
              </Box>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="xl" className="main-content">
          <Box className="hero-section">
            <Box className="hero-logo">
              <img src={"/Images/pls369logo.png"} alt="PLS369" className="hero-logo-image" />
            </Box>
          </Box>

          <Box className="video-and-dex-container">
            <Box className="video-section">
              <Typography variant="h6" className="section-title">
                LATEST NEWS
              </Typography>
              <Box className="video-wrapper">
                <VideoPlayer src={"/Videos/PLS369News1.1.mp4"} className="promo-video" />
              </Box>
            </Box>

            <Box className="gopulsex-container">
              <Typography variant="h6" className="section-title">
                TRADE NOW
              </Typography>
              <Box className="widget-wrapper">
                <iframe
                  src="https://gopulse.com/x/embed?out=0xF46DbFdB381e90B97586eD792b5201FCeCc93Ef0"
                  className="gopulsex-widget"
                  title="GoPulseX Widget"
                  frameBorder="0"
                />
              </Box>
            </Box>
          </Box>

          <Box className="stats-grid">
            <Box className="stat-box">
              <Typography variant="h6">Price</Typography>
              <Typography variant="h4">
                ${parseFloat(tokenData.price).toFixed(8)}
              </Typography>
              <Typography
                variant="body2"
                className={
                  parseFloat(tokenData.priceChange24h) >= 0
                    ? "positive"
                    : "negative"
                }
              >
                {parseFloat(tokenData.priceChange24h).toFixed(2)}% (24h)
              </Typography>
            </Box>
            <Box className="stat-box">
              <Typography variant="h6">Market Cap</Typography>
              <Typography variant="h4">
                {formatNumber(tokenData.marketCap)}
              </Typography>
            </Box>
            <Box className="stat-box">
              <Typography variant="h6">24h Volume</Typography>
              <Typography variant="h4">
                {formatNumber(tokenData.volume24h)}
              </Typography>
            </Box>
            <Box className="stat-box">
              <Typography variant="h6">PulseX V2 Liquidity</Typography>
              <Typography variant="h4">
                {formatNumber(tokenData.liquidity)}
              </Typography>
            </Box>
            <Box className="stat-box">
              <Typography variant="h6">Buy/Sell</Typography>
              <Typography variant="h4">
                {tokenData.trades24h
                  ? `${tokenData.trades24h.buys}/${tokenData.trades24h.sells}`
                  : "0/0"}
              </Typography>
              {tokenData.trades24h && (
                <Box className="percentage-display">
                  <Typography variant="body2" className="positive">
                    {(
                      (tokenData.trades24h.buys /
                        (tokenData.trades24h.buys +
                          tokenData.trades24h.sells)) *
                      100
                    ).toFixed(1)}
                    %
                  </Typography>
                  <Typography variant="body2">/</Typography>
                  <Typography variant="body2" className="negative">
                    {(
                      (tokenData.trades24h.sells /
                        (tokenData.trades24h.buys +
                          tokenData.trades24h.sells)) *
                      100
                    ).toFixed(1)}
                    %
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          <Box className="trump-pump-section">
            <Typography variant="h6" className="section-title">
              TRUMP PUMP
            </Typography>
            <Box className="video-container">
              <VideoPlayer src={"/Videos/TrumpPumpVideo.mp4"} />
            </Box>
          </Box>

          <Box className="lore-section">
            <Typography variant="h6" className="section-title">
              LORE
            </Typography>
            <Box className="lore-content">
              <Typography className="lore-text">
                COMMUNITY TAKEOVER! Believe in something... believe in PLS369.
                The premiere cult community with diamond hands. What's so
                special about 369? Well, it's not just PulseChain's Chain ID—
                it's got some serious secrets! In math, they say 369 holds the
                "keys to the universe." Nikola Tesla believed these numbers were
                the secret to unlocking the mysteries of energy, frequency, and
                vibration. And in our world, they are the ultimate test of
                faith. So buckle up, Richard Heart chose this number for a
                reason, and remember: 369 is our cult... our religion!
              </Typography>
            </Box>
          </Box>

          <Box className="how-to-join-section">
            <Typography variant="h6" className="section-title">
              STAY UPDATED
            </Typography>
            <Box className="how-to-join-content">
              <Typography className="how-to-join-text">
                1. Follow the official X account @369PLS
                <br />
                2. Head to the Telegram.
                <br />
                3. Buy more PLS369 to strengthen the community.
                <br />
                4. Join X spaces and discuss your thoughts! The future is being
                crafted by those who dare to believe in something... believe in
                PLS369.
              </Typography>

              <Typography className="how-to-join-text">
                *Remember DYOR and NFA*
              </Typography>
            </Box>
          </Box>

          <Box className="phonk-section">
            <Box className="video-section">
              <Typography variant="h6" className="section-title">
                PHONK
              </Typography>
              <Box className="video-container">
                <VideoPlayer src={"/Videos/PHONKedit369.mp4"} className="promo-video" />
                </Box>
            </Box>
          </Box>

          <Box className="youtube-section">
            <Typography variant="h6" className="section-title">
              FEATURED VIDEO
            </Typography>
            <Box className="video-container">
              <iframe
                width="100%"
                height="600"
                src="https://www.youtube.com/embed/3MRdi8cghfM?start=690"
                title="Featured Video"
              />
            </Box>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default App;
